type SessionExpiredListener = () => void;

const SESSION_EXPIRED_KEY = 'sessionExpired';

// Auth endpoints answer 401 for wrong credentials or an already invalid token: that is not an
// expired session, the caller handles it.
const AUTH_URL_PREFIXES = ['/api/authentication/', '/token/'];

const listeners = new Set<SessionExpiredListener>();

const onSessionExpired = (listener: SessionExpiredListener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Tells whether a 401 on this request means the logged-in user's session has expired.
 * Once the first 401 triggered the logout, `islogin` is false and the other in-flight
 * requests failing with 401 are ignored.
 */
const isSessionExpiredResponse = (status: number, url: string): boolean =>
  status === 401 &&
  sessionStorage.getItem('islogin') === 'true' &&
  !AUTH_URL_PREFIXES.some((prefix) => url.startsWith(prefix));

const notifySessionExpired = () => {
  listeners.forEach((listener) => listener());
};

export { isSessionExpiredResponse, notifySessionExpired, onSessionExpired, SESSION_EXPIRED_KEY };
